import React from "react";
import {Col, Row} from "reactstrap";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {RouteDefine} from "../../../../routes/RouteDefine";
import {SetupLinkKey} from "../../../../common/helpers/checkSetup";

export type {SetupLinkKey};

interface Props {
    missing?: SetupLinkKey[];
}

const LABEL_KEYS: Record<SetupLinkKey, string> = {
    invoice: 'log.setup_invoices',
    payment: 'log.setup_payments',
    payout: 'log.setup_payouts',
    subscription: 'log.setup_subscriptions',
    common: 'log.setup_general',
};

const BodyModalMessageSetupComponent = ({
    missing = ['invoice', 'common'],
}: Props) => {
    const {t} = useTranslation();
    const links: SetupLinkKey[] = missing.length ? missing : ['invoice', 'common'];
    const primary = links[0];

    return (
        <React.Fragment>
            <Row>
                <Col>
                    <div className="mb-3">
                        <p>{t("log.complete_setup")}</p>
                        <ul className="mb-3">
                            {links.map((key: SetupLinkKey) => (
                                <li key={key}>
                                    <Link to={`${RouteDefine.settingsEconomic}?setup=${key}`}>
                                        {t(LABEL_KEYS[key])}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                        <Link
                            className="btn btn-sm bg-orange-zp"
                            to={`${RouteDefine.settingsEconomic}?setup=${primary}`}
                        >
                            {t("log.go_to_setup")}
                        </Link>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BodyModalMessageSetupComponent;
